import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './';

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
  baseQuery: axiosBaseQuery(),
  endpoints: () => ({}),
  tagTypes: ['Customers', 'CustomerEnrolments', 'Sessions', 'Enrolment', 'OrganisationPermissions'],
});
